import { Api } from "../api/api";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { AlertController } from "ionic-angular";

@Injectable()
export class ConfirmationImageProvider {
  constructor(
    public http: HttpClient,
    public api: Api,
    public alertCtrl: AlertController
  ) {}

  toBlob(base64: string): Blob {
    const bin = atob(base64.replace(/^.*,/, ""));
    let buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }
    const blob = new Blob([buffer.buffer], { type: "image/png" });
    return blob;
  }

  buildFormData(imageData): FormData {
    const formData: FormData = new FormData();
    const blobImage: Blob = this.toBlob(imageData);
    formData.append("image", blobImage, imageData.name);
    return formData;
  }

  showUploadError(error: any) {
    console.log(error);
    const alert = this.alertCtrl.create({
      title: "エラー",
      subTitle: "画像のアップロードに失敗しました",
      buttons: [
        {
          text: "OK",
        },
      ],
    });
    alert.present();
  }
}

export class AgeVerificationProvider extends ConfirmationImageProvider {
  post(imageData: any): Observable<any> {
    const url: string = "me/age_verification_images";
    const formData: FormData = this.buildFormData(imageData);
    return this.api.post(url, formData, true);
  }
}

export class IncomeProofProvider extends ConfirmationImageProvider {
  post(imageData: any): Observable<any> {
    const url: string = "me/income_proof_images";
    const formData: FormData = this.buildFormData(imageData);
    return this.api.post(url, formData, true);
  }
}

export class AssetProofProvider extends ConfirmationImageProvider {
  post(imageData: any): Observable<any> {
    const url: string = "me/asset_proof_images";
    const formData: FormData = this.buildFormData(imageData);
    return this.api.post(url, formData, true);
  }
}



// WEBPACK FOOTER //
// ./src/providers/confirmation-image/confirmation-image.ts